<template>
	<div>
		<p class="font-medium text-gray-700" v-if="!noLabel">
			{{ __("Desired location") }}
		</p>

		<div class="flex space-x-6 mt-1 mb-4">
			<ui-radio-group
				class="col-span-2"
				v-model="form.location.mode"
				radioValue="FCA"
				:key="'FCA-' + form.location.mode"
				name="location.mode"
				label="Free Carrier (FCA)"
				tooltip-text="The buyer is responsible for freight costs from the place of loading."
				@change="setOptionalTransport()"
			>
			</ui-radio-group>
			<ui-radio-group
				class="col-span-2"
				v-model="form.location.mode"
				radioValue="DAP"
				:key="'DAP-' + form.location.mode"
				name="location.mode"
				label="Carried Paid To (CPT)"
				tooltip-text="The seller carries the transport responsibility and costs to the destination."
				@change="setOptionalTransport()"
			>
			</ui-radio-group>
			<ui-radio-group
				class="col-span-2"
				v-model="form.location.mode"
				radioValue="FOB"
				:key="'FOB-' + form.location.mode"
				name="location.mode"
				label="FOB"
				tooltip-text="The seller loads the traded goods onto the buyer's vessel and bears the costs and risks until the goods are fully loaded."
				v-if="canSeeFobCif && !hideFobCif"
				@change="setOptionalTransport()"
			>
			</ui-radio-group>
			<ui-radio-group
				class="col-span-2"
				v-model="form.location.mode"
				radioValue="CIF"
				:key="'CIF-' + form.location.mode"
				name="location.mode"
				label="CIF"
				tooltip-text="The seller carries the transport and insurance costs and the risks for transport to the agreed port of destination."
				v-if="canSeeFobCif && !hideFobCif"
				@change="setOptionalTransport()"
			>
			</ui-radio-group>
		</div>

		<crop-location-picker
			v-model="form.location.address"
			prefix="location"
			:form="form"
		></crop-location-picker>

		<!--ui-check-group
			class="pt-3"
			:form="form"
			field="location.optional_transport"
			v-model="form.location.optional_transport"
			:label="
				form.location.mode == 'DAP' && form.trade == 'BUY'
					? 'Pick-up possible upon request'
					: 'Delivery possible upon request'
			"
			v-if="
				form.location.mode &&
				form.type == 'OFFER' &&
				(form.location.mode == 'FCA' || form.location.mode == 'DAP')
			"
		/-->
		<div
			class="flex items-center pt-3"
			v-if="
				form.location.mode &&
				form.type == 'OFFER' &&
				(form.location.mode == 'FCA' || form.location.mode == 'DAP')
			"
		>
			<input
				type="checkbox"
				id="location_optional_transport"
				v-model="form.location.optional_transport"
				class="mt-0.5 h-5 w-5 border-gray-300 hover:border-gray-500 rounded cursor-pointer"
				:class="
					optionalTransportDisabled
						? 'text-gray-400 focus:ring-gray-400 bg-gray-200'
						: 'text-orange-500 focus:ring-orange-500'
				"
				:disabled="optionalTransportDisabled"
			/>
			<div class="">
				<label
					class="pl-3 block font-medium text-gray-700 cursor-pointer"
					for="location_optional_transport"
				>
					{{ __(optionalTransportText) }}
				</label>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		noLabel: {
			type: Boolean,
			default: false,
		},
		hideFobCif: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		canSeeFobCif() {
			let acl = this.$inertia.page.props.acl;
			if (acl.can_fob_cif) {
				return true;
			}
			return false;
		},
		optionalTransportDisabled() {
			if (
				(this.form.trade == "SELL" && this.form.location.mode == "DAP") ||
				(this.form.trade == "BUY" && this.form.location.mode == "FCA")
			) {
				return true;
			}
			return false;
		},
		optionalTransportText() {
			return this.form.location.mode == "DAP" && this.form.trade == "BUY"
				? "Pick-up possible upon request"
				: "Delivery possible upon request";
		},
	},
	methods: {
		setOptionalTransport: function () {
			if (this.form.trade == "SELL" && this.form.location.mode == "DAP") {
				this.form.location.optional_transport = true;
			} else if (this.form.trade == "BUY" && this.form.location.mode == "FCA") {
				this.form.location.optional_transport = false;
			} else if (
				this.form.location.mode == "FOB" ||
				this.form.location.mode == "CIF"
			) {
				this.form.location.optional_transport = false;
			}
		},
	},
};
</script>
